<div class="header-bar" >

  <div class="operational-support-tool" i18n="sample | sample text. @@ProjectTitle">
    Knowledge Middle Layer
  </div>
  <div class="breadcrumb-container border-left ml-2" *ngIf="commService.currentUserRole.IsHome">
    <app-breadcrumb></app-breadcrumb>
  </div>


  <div class="right-buttons" *ngIf="commService.currentUserRole.IsHome">   
    <div>
      <div class="dp">
        <i class="fa fa-user-circle" aria-hidden="true"></i>
      </div>
      <div class="kat-user-name">
        <span>
          {{loggedUser.FirstName}} {{loggedUser.LastName }}
        </span>

        <div class="design" *ngIf="commService.currentUserRole.IsAdmin">
          Administrator
        </div>
      </div>
      <div *ngIf="loggedUser.FirstName" class="logout" (click)="signout()">
        <i title="Signout" class="fa fa-sign-out" aria-hidden="true"></i>
      </div>
    </div>
  </div>

</div>